import React from 'react';
import api from '../../../api/apiClient';
import EventCalendarView from '../../../common/components/calendar/EventCalendarView';
import { EVENT_TYPE_META } from '../../../common/utils/calendarHelpers';

const INSTRUCTOR_CALENDAR_LEGEND = [
  EVENT_TYPE_META.vilt,
  EVENT_TYPE_META.assessment
];

const InstructorEventCalendarPage = () => (
  <EventCalendarView
    title="Event Calendar"
    description="VILT sessions, live meetings, and assessment schedules for your organization."
    emptyMessage="Your scheduled VILT, meetings, and assessment events will appear here."
    legendItems={INSTRUCTOR_CALENDAR_LEGEND}
    vltPath="/instructor/vlt"
    assessmentMode="instructor"
    loadEvents={async ({ start, end }) => {
      const response = await api.calendar.getInstructorEvents({ start, end });
      return response.data?.data || [];
    }}
  />
);

export default InstructorEventCalendarPage;
